/* ORAVIE bundle picker. Keeps the selected card, and the single mobile button,
   in step with the shopper's choice. Adding to cart is left to the theme's cart
   script (assets/oravie-cart.js), which already handles every /cart/add form;
   without JavaScript each card's own form still posts normally. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__opdpBundles) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bun-card]'));
    if (!cards.length) return;
    root.__opdpBundles = true;

    var shared = root.querySelector('[data-bun-shared]');
    var sharedId = shared && shared.querySelector('input[name="id"]');
    var sharedBtn = shared && shared.querySelector('button[type="submit"]');
    var sharedLabel = shared && shared.querySelector('[data-bun-cta]');
    var soldOut = shared ? shared.getAttribute('data-sold-out') : '';

    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        var radio = c.querySelector('input[type="radio"]');
        if (radio && radio.checked !== on) radio.checked = on;
      });
      if (!shared || !sharedId) return;
      var available = card.getAttribute('data-available') === 'true';
      sharedId.value = card.getAttribute('data-variant-id');
      if (sharedBtn) sharedBtn.disabled = !available;
      if (sharedLabel) sharedLabel.textContent = available ? card.getAttribute('data-cta') : soldOut;
    }

    cards.forEach(function (card) {
      var radio = card.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) select(card);
        });
      }
      var form = card.querySelector('form');
      if (form) {
        form.addEventListener('submit', function () { select(card); });
      }
    });

    /* Theme editor: selecting a bundle block highlights its card. */
    root.addEventListener('shopify:block:select', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('[data-bun-card]') : null;
      if (card) select(card);
    });

    var initial = cards.filter(function (c) { return c.classList.contains('is-selected'); })[0] || cards[0];
    select(initial);
    root.classList.add('is-ready');
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-opdp-bundles]'), init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
